/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _|
 | |_| | | | | |_) || |  / / | | |  \| | | | | || |
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|

=========================================================
* Horizon UI - v1.0.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2022 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import {
  Box,
  SimpleGrid,
} from "@chakra-ui/react";
import axios from "axios";
// Custom components
import React, { useEffect, useState } from "react";
import {
} from "react-icons/md";
import ComplexTable from "views/admin/dao-verif/components/ComplexTable";
import { Ripple } from 'react-spinners-css';

import {
  columnsDataComplex,
} from "views/admin/dao/variables/columnsData";

export default function UserReports() {
  const [proposals, setProposals] = useState();
  const [isMutating, setisMutating] = useState(true);


  useEffect(async () => {
    //TODO: autre route
    if (isMutating) {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/proposals`)
        .catch(e => console.error(e));
      const data = response?.data?.filter(item => item.status === "PENDING_ADMIN_APPROVAL");
      setProposals(data);
      setisMutating(false);
    }
  }, [isMutating])

  // Chakra Color Mode
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, "2xl": 3 }}
        gap='20px'
        mb='20px'>
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 1, xl: 1 }} gap='20px' mb='20px'>
        {proposals ?
          <ComplexTable
            columnsData={columnsDataComplex}
            tableData={proposals}
            setisMutating={setisMutating}
          /> : <Box gap='20px' display='flex' justifyContent='center' alignItems='center'>
            <Ripple color='#efbc5e' />
          </Box>
        }
      </SimpleGrid>
    </Box>
  );
}
